import type { WorkspaceItem } from '@pn/core/domain/workspace';
import { handleError } from '@pn/core/errors/handleError';
import { workspaceActions } from '@pn/core/storage';
import { apiWorkspaceItemsProvider } from '@pn/services/api/workspace/apiWorkspaceItemsProvider';

export async function deleteWorkspaceItem(item: WorkspaceItem): Promise<void> {
  try {
    if (!item.isTemporary) {
      await apiWorkspaceItemsProvider.deleteItem(item);
    }

    workspaceActions().remove(item);
  } catch (error) {
    handleError({
      error,
      notify: `Failed to delete ${item.itemType === 'drawing' ? 'annotation' : item.itemType}`,
    });
  }
}
